(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  const getReviewCarouselStep = (track) => {
    const card = track.querySelector('.nb-reviews-carousel__card');
    if (!card) return track.clientWidth;

    const styles = getComputedStyle(track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || 0) || 0;

    return card.getBoundingClientRect().width + gap;
  };

  const scrollReviewCarousel = (track, direction = 1) => {
    const maxScroll = track.scrollWidth - track.clientWidth;
    const step = getReviewCarouselStep(track);
    const nextLeft = track.scrollLeft + direction * step;

    if (direction > 0 && nextLeft >= maxScroll - 2) {
      track.scrollTo({ left: maxScroll <= step ? maxScroll : 0, behavior: 'smooth' });
      return;
    }

    if (direction < 0 && nextLeft <= 2) {
      track.scrollTo({ left: track.scrollLeft <= 2 ? maxScroll : 0, behavior: 'smooth' });
      return;
    }

    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  };

  const setupReviewCarouselAutoplay = (section) => {
    if (section.dataset.nbReviewsAutoplay !== 'true' || section.dataset.nbReviewsAutoplayReady === 'true') return;

    const track = section.querySelector('[data-nb-reviews-track]');
    if (!track || track.scrollWidth <= track.clientWidth) return;

    section.dataset.nbReviewsAutoplayReady = 'true';

    const interval = Number(section.dataset.nbReviewsAutoplayInterval || 4000);
    let isPaused = false;

    section.addEventListener('pointerenter', () => {
      isPaused = true;
    });
    section.addEventListener('pointerleave', () => {
      isPaused = false;
    });
    section.addEventListener('focusin', () => {
      isPaused = true;
    });
    section.addEventListener('focusout', () => {
      isPaused = false;
    });

    window.setInterval(() => {
      if (isPaused || document.hidden) return;
      scrollReviewCarousel(track, 1);
    }, interval);
  };

  const setupReviewCarousels = (root = document) => {
    root.querySelectorAll('.nb-reviews-carousel').forEach(setupReviewCarouselAutoplay);
  };

  const syncReviewCarouselFromHome = async (section) => {
    if (section.dataset.nbReviewsHomeSyncReady === 'true') return;

    section.dataset.nbReviewsHomeSyncReady = 'true';

    try {
      const response = await fetch(section.dataset.nbReviewsHomeUrl || '/', {
        credentials: 'same-origin',
      });
      if (!response.ok) return;

      const html = await response.text();
      const documentFromHome = new DOMParser().parseFromString(html, 'text/html');
      const source = documentFromHome.querySelector('.nb-reviews-carousel:not([data-nb-reviews-sync-home="true"])');
      if (!source) return;

      const syncedSection = source.cloneNode(true);
      section.replaceWith(syncedSection);
      setupReviewCarousels(syncedSection);
    } catch (error) {
      section.dataset.nbReviewsHomeSyncReady = 'false';
    }
  };

  const syncReviewCarouselsFromHome = (root = document) => {
    root.querySelectorAll('.nb-reviews-carousel[data-nb-reviews-sync-home="true"]').forEach(syncReviewCarouselFromHome);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-nb-reviews-direction]');
    if (!button) return;

    const section = button.closest('.nb-reviews-carousel');
    const track = section?.querySelector('[data-nb-reviews-track]');
    if (!track) return;

    scrollReviewCarousel(track, Number(button.dataset.nbReviewsDirection || 1));
  });

  document.addEventListener('shopify:section:load', (event) => {
    setupReviewCarousels(event.target);
    syncReviewCarouselsFromHome(event.target);
  });
  setupReviewCarousels();
  syncReviewCarouselsFromHome();

  } catch(e) { console.error(e); }
})();
})();
